import React from "react";
import { useTranslation } from "react-i18next";
import { useHistory, useParams } from "react-router";
import { toast } from "react-toastify";
import { useGetPartList } from "../../hooks";
import * as API from "../../lib/api.js";
import UploadBase64 from "../../lib/builder/base64.js";
import Wait from "../Wait";
import WizardFormEdit from "../Wizard/WizardFormEdit.jsx";

export default function WebsiteContent() {
    const { t } = useTranslation();
    const { id, step } = useParams();

    const history = useHistory();
    const PartList = useGetPartList({ type: "content" }) || []; // Default

    const [wait, setWait] = React.useState(false);
    const [loading, setLoading] = React.useState(true);
    const [currentPart, setCurrentPart] = React.useState(step || PartList[0]?.key);
    const [project, setProject] = React.useState(null);
    const [variables, setVariables] = React.useState({});

    const [prevVariablesJSON, setPrevVariablesJSON] = React.useState(null);

    React.useEffect(() => {
        id && Load(id);
    }, [id]);

    function Load(id_project) {
        setLoading(true);

        return Promise.all([API.WizardLoad(), API.Send("/project/get", { id_project })])
            .then(async ([{ partKey }, project]) => {
                if (!project?.ok) {
                    return null;
                }

                partKey && setCurrentPart(partKey);
                setProject(project);
                setVariables(project.variables);
                setPrevVariablesJSON(JSON.stringify(project.variables));
            })
            .finally(() => setLoading(false));
    }

    function SaveWizardStep(newPart) {
        return API.WizardSave({ partKey: newPart?.key ?? currentPart }).then(() => setCurrentPart(newPart));
    }

    function onSaveClick() {
        const Project = { ...project, variables };
        Project.id_project = Project.id;

        if (prevVariablesJSON !== JSON.stringify(variables)) {
            variables.dateModified = Date.now();
        }

        setWait(true);
        API.ProjectUpdate(Project)
            .then(() => API.WizardSave({}))
            .then(() => UploadBase64({ id_project: Project.id_project, variables }))
            .then(() => API.ProjectUpdate(Project))
            .then(() => history.goBack())
            .catch(err => err?.errors?.forEach(err => toast.error(t(err.error))))
            .finally(() => setWait(false));
    }

    function onCancelClick() {
        setWait(true);
        return API.WizardSave({})
            .then(() => history.goBack())
            .then(() => setWait(false));
    }

    const wizardProps = {
        currentPart,
        setCurrentPart: SaveWizardStep,
        variables,
        setVariables,

        startPart: PartList[0],
        onCancel: onCancelClick,
        onSave: onSaveClick,

        Refresh: Load,
    };

    return (
        <>
            <div className="website-text">
                {loading && <h2 className="panel-heading-text">{t("Loading")}...</h2>}
                {!loading && project && <WizardFormEdit {...wizardProps} />}
            </div>

            <Wait show={wait} />
        </>
    );
}
